<app-edit-form [data]="config$ | async" [metadata]="metadata$ | async" [isConfigExist]="isConfigExist"
               (postConfig)="createOrEditConfig($event)"></app-edit-form>
